import React, { useState } from 'react';
import T from 'prop-types';

import { locationDataProp } from './locationData';
import { StripeWrapper } from './StripeWrapper';
import { SignupForm } from './SignupForm';
import { UpgradeForm } from './UpgradeForm';
import { BillingAddressProps, Header, PackageDetails } from './shared';

const SubscriptionForm = (props) => {
  const { companyDetails, billingAddress, packageDetails, locationData, stripe, title, subTitle, isUpgrade } = props;
  const [clientSecret, setClientSecret] = useState('');

  const formDetails = isUpgrade
    ? {
        stripePublishableKey: stripe.publishableKey,
        stripeClientSecretPath: stripe.clientSecretPath,
        companyName: companyDetails.name,
        billingEmail: companyDetails.billingEmail,
        addressLineOne: billingAddress.lineOne,
        addressLineTwo: billingAddress.lineTwo,
        city: billingAddress.city,
        countryCode: billingAddress.countryCode,
        region: billingAddress.region,
        postCode: billingAddress.postCode,
        vatNumber: companyDetails.vatNumber,
        package: packageDetails.packageId,
        locationData,
      }
    : {
        stripePublishableKey: stripe.publishableKey,
        stripeClientSecretPath: stripe.clientSecretPath,
        package: packageDetails.packageId,
        locationData,
      };

  const defaultSubTitle = (
    <>
      Sign up for {packageDetails.packageName}, or <a href="/pricing">review all our packages</a>.
    </>
  );

  return (
    <div className="px-4 sm:px-8 md:px-10 lg:px-16 font-normal max-w-screen-xl mx-auto">
      <Header title={title} subTitle={subTitle ?? defaultSubTitle} />
      <div className="flex flex-col md:flex-row gap-0 md:gap-8">
        <PackageDetails packageDetails={packageDetails} additionalCSS={'flex-1'} />
        <div className="flex-1 pt-16 md:pt-0">
          <StripeWrapper stripe={stripe}>
            {(fetchedClientSecret, refetchClientSecret) =>
              isUpgrade ? (
                <UpgradeForm
                  {...formDetails}
                  clientSecret={clientSecret || fetchedClientSecret}
                  refetchClientSecret={refetchClientSecret}
                  updateClientSecret={setClientSecret}
                />
              ) : (
                <SignupForm
                  {...formDetails}
                  clientSecret={clientSecret || fetchedClientSecret}
                  refetchClientSecret={refetchClientSecret}
                  updateClientSecret={setClientSecret}
                />
              )
            }
          </StripeWrapper>
        </div>
      </div>
    </div>
  );
};

SubscriptionForm.propTypes = {
  title: T.string,
  subTitle: T.string,
  stripe: T.object,
  packageDetails: T.object,
  locationData: locationDataProp,
  companyDetails: T.object,
  billingAddress: BillingAddressProps,
  isUpgrade: T.bool,
};

export { SubscriptionForm };
